// @flow

import type {PaymentMethod} from '@tectonics/commons/new-payment-methods/payment-method';
import React from 'react';
import {
  DisplayGuatemalanCashBrands,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/payment-method-selector/payment-method-item/display-brands/display-guatemalan-cash-brand';
import {cashGuatemalanOutgoingPaymentMapper} from '@tectonics/prs/cash-guatemala';

export const CashGuatemala: PaymentMethod = {
  code: 'cash',
  nameKey: 'volcanes.puntoxpress.name',
  placeOrderMessageKey: 'volcanes.puntoxpress.placeOrder',
  icons: <DisplayGuatemalanCashBrands />,
  outgoingPaymentMapper: cashGuatemalanOutgoingPaymentMapper,
};
